module.exports = __webpack_public_path__ + "Verlag-Bold.otf?8c4f8f796dd04103f26d9a0baf919122";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/verlag/Verlag-Bold.otf
// module id = 310
// module chunks = 0